module.exports = __webpack_public_path__ + "static/work67-90e7233ab82bd74185b015b295443caa.jpg";